import { defineMessages } from "react-intl";

export const totpResetSearchMessages = defineMessages({
  required: {
    id: "totp-reset.reset-code-required",
    defaultMessage: "Отсутствует обязательное значение",
  },
  type: {
    id: "totp-reset.reset-code-string",
    defaultMessage: "Значение должно быть строкой",
  },
});
